// VendorSelectionCardSkeleton.js
import React from "react";
import Skeleton from "react-loading-skeleton";

const VendorSelectionCardSkeleton = () => {
  return (
    <div className="vendor-selection-card">
      {/* <Checkbox disabled /> */}
      <div className="vendor-name">
        <Skeleton variant="text" width={100} height={20} animation="wave" />
      </div>
      <p className="price">
        <Skeleton variant="text" width={80} height={20} animation="wave" />
      </p>
    </div>
  );
};

export default VendorSelectionCardSkeleton;
